import DVCore from "./core/DVCore";

const MyAppsAPI = {};

MyAppsAPI.baseURL = "/api/myapps/";

MyAppsAPI.list = (onSuccess, onFail, onError = null) => {
    return DVCore.get(MyAppsAPI.baseURL, null, onSuccess, onFail, onError);
};

MyAppsAPI.get = (appId, onSuccess, onFail, onError = null) => {
    return DVCore.get(MyAppsAPI.baseURL + appId, null, onSuccess, onFail, onError);
};

MyAppsAPI.create = (data, onSuccess, onFail, onError = null) => {
    return DVCore.post(MyAppsAPI.baseURL, data, onSuccess, onFail, onError);
};

MyAppsAPI.update = (appId, data, onSuccess, onFail, onError = null) => {
    const body = JSON.stringify(data);
    return DVCore.fetch("PATCH", MyAppsAPI.baseURL + appId, body, onSuccess, onFail, onError);
};

MyAppsAPI.rotateSecret = (appId, onSuccess, onFail, onError = null) => {
    return DVCore.post(MyAppsAPI.baseURL + appId + "/rotate-secret", {}, onSuccess, onFail, onError);
};

MyAppsAPI.remove = (appId, onSuccess, onFail, onError = null) => {
    return DVCore.delete(MyAppsAPI.baseURL + appId, onSuccess, onFail, onError);
};

export default MyAppsAPI;
